<template>
  <div class="loadingDiv no-gutters">
    <img class="loadingDiv__icon" src="static/images/main_loading.gif" width="120px" />
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen'
};
</script>

<style lang="scss">
  .loadingDiv {
    position: absolute;
    top: 0;
    left:0;
    right:0;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.5);
    z-index: 1000;
    text-align: center;
    .loadingDiv__icon {
    position: relative;
    top:20%;
    overflow: hidden;
    white-space: nowrap;

      z-index: 1001;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue